import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Sequencer is a web application that is designed to test the sequencing ability of young children, and was used in a research study with children aged 5 and 6. It has players order 4 cards that make up a story. The app contains 30 stories, which were designed and drawn by myself and `}
      <a href="https://www.artstation.com/calebobrien" target="_blank">{`Caleb O'Brien`}</a>
      {` and depict sequences in five categories (which were used as an indicator of difficulty):`}</p>
    <ol>

      <li {...{
        "parentName": "ol"
      }}>{`Mechanical 1 (objects interacting causally with each other)`}</li>


      <li {...{
        "parentName": "ol"
      }}>{`Mechanical 2 (people and objects acting causally on each other)`}</li>


      <li {...{
        "parentName": "ol"
      }}>{`Behavioural 1 (a single person acting out everyday routines)`}</li>


      <li {...{
        "parentName": "ol"
      }}>{`Behavioural 2 (people acting in social routines)`}</li>


      <li {...{
        "parentName": "ol"
      }}>{`Intentional (people acting in everyday activities requiring the attribution of mental states)`}</li>

    </ol>
    <p>{`It was written using the MEAN stack (MongoDB, AngularJS, Express.js and Node.js) with TypeScript.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      